import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-data-personal',
  templateUrl: './terms-data-personal.component.html',
  styleUrls: ['./terms-data-personal.component.scss']
})
export class TermsDataPersonalComponent {

  constructor() { }
}
